@include button-container;

.button-container {

  a {
    @include text-main;
    color: var(--font-color-main);

    &.is-button {
      width: fit-content;
      white-space: nowrap;

      &.custom-width {
        min-width: 100%;
      }
    }
  }
}
